export default "__VITE_ASSET__D4KkliP8__"